module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customCloudAccountsTable.noData":"No custom cloud connections configured."}}')
  delete Component.options._Ctor
}
